import type { SessionTokenDecoderPort } from "../../../application/ports/SessionTokenDecoderPort";
import type { CheckoutSession } from "../../../domain/entities/CheckoutSession";
import { InvalidSessionTokenError } from "../../../domain/errors/InvalidSessionTokenError";
import { createCountryCode } from "../../../domain/value-objects/CountryCode";
import { createOrderId } from "../../../domain/value-objects/OrderId";
interface TokenPayload {
  orderId: string;
  authorizationToken: string;
  countryCode: string;
}

export class StaticSessionTokenDecoderAdapter implements SessionTokenDecoderPort {
  async decode(token: string): Promise<CheckoutSession> {
    if (!token) {
      throw new InvalidSessionTokenError("El parámetro token de sesión es obligatorio");
    }

    const parts = token.split(".");

    if (parts.length < 2) {
      throw new InvalidSessionTokenError("El token de sesión no tiene formato JWT válido");
    }

    try {
      const payload = JSON.parse(this.decodeBase64Url(parts[1])) as TokenPayload;

      if (!payload.orderId || !payload.authorizationToken || !payload.countryCode) {
        throw new InvalidSessionTokenError("Al token de sesión le faltan campos obligatorios");
      }

      return {
        orderId: createOrderId(payload.orderId),
        authorizationToken: payload.authorizationToken,
        countryCode: createCountryCode(payload.countryCode),
        rawToken: token,
      };
    } catch (error) {
      if (error instanceof InvalidSessionTokenError) {
        throw error;
      }

      throw new InvalidSessionTokenError("No fue posible decodificar el token de sesión");
    }
  }

  private decodeBase64Url(value: string): string {
    const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), "=");

    const globalAtob = typeof globalThis === "object" ? (globalThis as typeof globalThis & { atob?: typeof atob }).atob : undefined;

    if (!globalAtob) {
      throw new InvalidSessionTokenError("La decodificación Base64 no está disponible en este entorno");
    }

    return globalAtob(padded);
  }
}
